module.exports = __webpack_public_path__ + "img/Avatar-64.7f09741b.svg";